import { OrganisationRoleSchema, type OrganisationRole } from '@ghostscreen/contracts';
import { formatDateTime, i18n } from '../../i18n';

function isOrganisationRole(role: string): role is OrganisationRole {
  return OrganisationRoleSchema.safeParse(role).success;
}

/** Short labels for Admin roster / badges. */
export function formatAdminRole(role: string): string {
  return isOrganisationRole(role) ? i18n.t(`common:roles.${role}`) : i18n.t('common:roles.member');
}

export function formatAdminDate(iso: string): string {
  try {
    return formatDateTime(iso, { dateStyle: 'medium' });
  } catch {
    return iso;
  }
}
